import React, { Component } from 'react';
import cx from 'classnames';
import ContentGenerator from 'components/ContentGenerator/ContentGenerator';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import PaymentMethodImg from 'images/payment-method.svg';
import advertiseImg from 'images/advertise-image.svg';
import giftCardImg from 'images/gift-cards-image.svg';
import HelpCentreimg from 'images/help-centre-image.svg';
import SellImg from 'images/sell-image.svg';
import omnitureHelper from 'utils/omnitureHelper';

import styles from './FooterNav.css';

const mailAddressConfig = [
	{
		type: 'markdown',
		data: stringTemplate('mailAddress'),
		className: styles['address']
	}
];
const registeredAddressConfig = [
	{
		type: 'markdown',
		data: stringTemplate('registredAddress'),
		className: styles['address']
	}
];

const getTrackClick = target => () => {
	omnitureHelper.trackLink({ ...omnitureHelper.getCommonPPFields(), events: 'event17', prop20: target });
};

export default class FooterNav extends Component {
	renderRow1 = () => {
		const { minimal, otracker } = this.props;

		if (minimal) {
			return null;
		}
		return (
			<div className={cx(styles['main-container'], 'row')}>
				<div className={styles['navcolumn']}>
					<div className={styles['heading']}>ABOUT</div>
					<a href={`/helpcentre?otracker=${otracker}_navlinks`} className={styles['link']}>
						Contact Us
					</a>
					<a href={`/about-us?otracker=${otracker}_navlinks`} className={styles['link']}>
						About Us
					</a>
					<a href={`https://www.flipkartcareers.com/?otracker=${otracker}_navlinks`} className={styles['link']}>
						Careers
					</a>
					<a href={`http://stories.flipkart.com/?otracker=${otracker}_navlinks`} className={styles['link']}>
						Flipkart Stories
					</a>
					<a href={`/s/press?otracker=${otracker}_navlinks`} className={styles['link']}>
						Press
					</a>
					<a
						href={`https://www.flipkartwholesale.com/?otracker=${otracker}_navlinks`}
						target="_blank"
						className={styles['link']}
					>
						Flipkart Wholesale
					</a>
				</div>
				<div className={styles['navcolumn']}>
					<div className={styles['heading']}>HELP</div>
					<a href={`/pages/payments`} className={styles['link']}>
						Payments
					</a>
					<a href={`/pages/shipping`} className={styles['link']}>
						Shipping
					</a>
					<a href={`/helpcentre?catalog=55c9c6edb000002e002c1701&view=CATALOG`} className={styles['link']}>
						Cancellation & Returns
					</a>
					<a href={`/helpcentre?catalog=55c9c8e2b0000023002c1702&view=CATALOG`} className={styles['link']}>
						FAQ
					</a>
					<a href={`https://seller.flipkart.com/fiv?otracker=${otracker}_navlinks`} className={styles['link']}>
						Report Infringement
					</a>
				</div>
				<div className={styles['navcolumn']}>
					<div className={styles['heading']}>POLICY</div>
					<a href={`/pages/returnpolicy?otracker=${otracker}_navlinks`} className={styles['link']}>
						Return Policy
					</a>
					<a href={`/pages/terms?otracker=${otracker}_navlinks`} className={styles['link']}>
						Terms Of Use
					</a>
					<a href={`/pages/paymentsecurity?otracker=${otracker}_navlinks`} className={styles['link']}>
						Security
					</a>
					<a href={`/pages/privacypolicy?otracker=${otracker}_navlinks`} className={styles['link']}>
						Privacy
					</a>
					<a href={`/sitemap?otracker=${otracker}_navlinks`} className={styles['link']}>
						Sitemap
					</a>
					<a href={`/pages/ewaste-compliance-tnc?otracker=${otracker}_navlinks`} className={styles['link']}>
						EPR Compliance
					</a>
				</div>
				<div className={styles['navcolumn']}>
					<div className={styles['heading']}>SOCIAL</div>
					<a href="https://www.facebook.com/flipkart" className={styles['link']}>
						Facebook
					</a>
					<a href="https://www.twitter.com/flipkart" className={styles['link']}>
						Twitter
					</a>
					<a href="https://www.youtube.com/flipkart" className={styles['link']}>
						YouTube
					</a>
				</div>

				<div className={cx(styles['navcolumn'], 'address')}>
					<div className={styles['mail-address']}>
						<div className={styles['heading']}>
							<StringWidget strKey="mailAddressHeader" />
						</div>
						<div className={styles['address']}>
							<ContentGenerator config={mailAddressConfig} />
						</div>
					</div>
				</div>

				<div className={cx(styles['navcolumn'], 'address')}>
					<div className={styles['corporate-address']}>
						<div className={styles['heading']}>
							<StringWidget strKey="registeredAddressHeader" />
						</div>
						<div className={styles['address']}>
							<ContentGenerator config={registeredAddressConfig} />
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderRow3 = () => {
		const { minimal, otracker } = this.props;
		return (
			<div>
				{minimal ? (
					<div className={styles['policy-min-container']}>
						<div className={cx(styles['policies-cart'], 'col col-8-12')}>
							<span>
								<span className="policies-title footertitle">Policies:</span>
								<a
									className={styles['policy-cart-link']}
									href="/returnpolicy"
									target="_blank"
									rel="noopener noreferrer"
								>
									Returns Policy
								</a>
								<a className={styles['policy-cart-link']} href="/s/terms" target="_blank" rel="noopener noreferrer">
									Terms of use
								</a>
								<a
									className={styles['policy-cart-link']}
									href="/s/paymentsecurity"
									target="_blank"
									rel="noopener noreferrer"
								>
									Security
								</a>
								<a
									className={styles['policy-cart-link']}
									href="/pages/privacypolicy"
									target="_blank"
									rel="noopener noreferrer"
								>
									Privacy
								</a>
								<a
									className={styles['policy-cart-link']}
									href="https://seller.flipkart.com/fiv"
									target="_blank"
									rel="noopener noreferrer"
								>
									Infringement
								</a>
							</span>
							<span className={cx(styles['fk-footer-copyright'])}>
								© 2007-{__CURRENT__YEAR__} <span>Flipkart.com</span>
							</span>
						</div>
						<div className={cx(styles['policies-cart'], styles['footer-icons'], 'col col-4-12')}>
							<span>Need help? </span>
							<span>
								Visit the
								<a
									href={`/s/help?otracker=${otracker}_navlinks`}
									className={styles['help-link']}
									target="_blank"
									rel="noopener noreferrer"
								>
									{' '}
									Help Center
								</a>{' '}
								or
								<a
									href={`/helpcentre?otracker=${otracker}_navlinks`}
									className={styles['help-link']}
									target="_blank"
									rel="noopener noreferrer"
								>
									{' '}
									Contact Us
								</a>
							</span>
						</div>
					</div>
				) : (
					<div className={styles['policies']}>
						<div className={styles['container']}>
							<img src={SellImg} />
							<a
								href="https://seller.flipkart.com/?utm_source=fkwebsite&utm_medium=websitedirect"
								onClick={getTrackClick('footer_sellonflipkart')}
							>
								<StringWidget strKey="sellonFlipkartText" className={styles['footer-last']} />
							</a>
						</div>
						<div className={styles['container']}>
							<img src={advertiseImg} />
							<a href="https://brands.flipkart.com" onClick={getTrackClick('footer_advertizeonflipkart')}>
								<StringWidget strKey="AdvertiseText" className={styles['footer-last']} />
							</a>
						</div>
						<div className={styles['container']}>
							<img src={giftCardImg} />
							<a
								href={`/the-gift-card-store?otracker=${otracker}_footer_navlinks`}
								onClick={getTrackClick('footer_giftcard')}
							>
								<StringWidget strKey="giftCardsText" className={styles['footer-last']} />
							</a>
						</div>
						<div className={styles['container']}>
							<img src={HelpCentreimg} />
							<a href={`/helpcentre?otracker=${otracker}_footer_navlinks`} onClick={getTrackClick('footer_helpcentre')}>
								<StringWidget strKey="helpCentertext" className={styles['footer-last']} />
							</a>
						</div>
						<span className={cx(styles['fk-footet-cr'])}>
							© 2007-{__CURRENT__YEAR__} <span>Flipkart.com</span>
						</span>
						<img src={PaymentMethodImg} className={styles['payment-img']} />
					</div>
				)}
			</div>
		);
	};

	render() {
		return (
			<div className={styles['footernav']}>
				{this.renderRow1()}
				{this.renderRow3()}
			</div>
		);
	}
}
